import React, { useEffect, useState } from "react";
import "./entity.css";
import {
  Drawer,
  Grid,
  Button,
  InputLabel,
  FormControl,
  TextField,
  InputAdornment,
  Typography,
  Alert,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CancelIcon from "@mui/icons-material/Cancel";
import BackDropLoaderApi from "../../Allloader/BackDropLoaderApi";

const Editmaintain = ({
  backDrop,
  isDrawerOpen,
  drawerWidth,
  handleDrawerCloseedit,
  maindata,
  entitytypedata,
  endpointtypedata,
  handle_EditEntity,
  error,
  success,
  handleCloseErrorcode,
}) => {
  const [information , setInformation] = useState({})
  const handleChange = (event) => {
    const { id, value } = event.target;
    const sanitizedValue =
    id === "recipient_endpoint_port" ? value.replace(/[^0-9]/g, "") : value;
    setInformation((prevData) => ({
      ...prevData,
      [id]: sanitizedValue,
    }));
  };
  useEffect(()=>{
    setInformation(maindata)
  },[maindata])
  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      PaperProps={{
        sx: {
          width: drawerWidth, 
        },
      }}
    >
      <BackDropLoaderApi open={backDrop} />
      <div
        style={{ padding: "20px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              id="back-button"
              variant="contained"
              color="transparent"
              className="button_back"
              onClick={handleDrawerCloseedit}
              startIcon={<ArrowBackIcon onClick={handleDrawerCloseedit}/>}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h5"
              className="font-color mb-0"
              style={{ fontWeight: "600" }}
            >
              Edit Entity{" "}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h7"
              className="font-color mb-1"
              style={{ fontWeight: "600" }}
            >
              Entity Information{" "}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {error && (
              <Alert
                variant="outlined"
                severity="error"
                icon={<CancelIcon onClick={handleCloseErrorcode} />}
                className="errorAlertMaintain mt-4"
              >
                {error}
              </Alert>
            )}
            {success && (
              <Alert
                variant="outlined"
                severity="success"
                className="sucessAlertMaintain mt-4"
              >
                {success}
              </Alert>
            )}
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="entity_name">Name<span style={{color:"red"}}>*</span></InputLabel>
            <TextField
              id="entity_name"
              size="small"
              value={information.entity_name}
              onChange={handleChange}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="autocomplete-search">Entity Type<span style={{color:"red"}}>*</span></InputLabel>
            <FormControl variant="outlined" fullWidth>
              <Autocomplete
                id="autocomplete-search"
                options={entitytypedata}
                value={entitytypedata.find((option) => option.entity_type_id === information.entity_type_id) || null}
                getOptionLabel={(option) => option.entity_type_name}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setInformation((prevData) => ({
                      ...prevData,
                      entity_type_id: newValue.entity_type_id || 0,
                      entity_type_name: newValue.entity_type_name || null,
                    }));
                  } else {
                    setInformation((prevData) => ({
                      ...prevData,
                      entity_type_id: 0,
                      entity_type_name:null,
                    }));
                  }
                }}
                disableClearable
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="outlined"
                    // InputProps={{
                    //   ...params.InputProps,
                    //   endAdornment: (
                    //     <InputAdornment
                    //       position="end"
                    //       style={{ position: "absolute", right: 20 }}
                    //     >
                    //       <img
                    //         src="assets/Images/searchicon.svg"
                    //         alt="Search Icon"
                    //       />
                    //     </InputAdornment>
                    //   ),
                    // }}
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <InputLabel htmlFor="entity_sender_code">Sender Code</InputLabel>
            <TextField
              id="entity_sender_code"
              size="small"
              value={information.entity_sender_code}
              onChange={handleChange}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <InputLabel htmlFor="entity_receiver_code">Receiver Code</InputLabel>
            <TextField
              id="entity_receiver_code"
              size="small"
              value={information.entity_receiver_code}
              onChange={handleChange}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="entity_org_code">Organisation Code</InputLabel>
            <TextField
              id="entity_org_code"
              size="small"
              value={information.entity_org_code}
              onChange={handleChange}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h7"
              className="font-color mb-1"
              style={{ fontWeight: "600" }}
            >
              Configuration
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="autocomplete-search">Endpoint Type<span style={{color:"red"}}>*</span></InputLabel>
            <FormControl variant="outlined" fullWidth>
              <Autocomplete
                id="autocomplete-search"
                options={endpointtypedata}
                value={endpointtypedata.find((option) => option.endpoint_type_id === information.recipient_endpoint_type_id) || null}
                getOptionLabel={(option) => option.endpoint_type_name}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setInformation((prevData) => ({
                      ...prevData,
                      recipient_endpoint_type_id:
                        newValue.endpoint_type_id || 0,
                        endpoint_type_name : newValue.endpoint_type_name || null,
                    }));
                  } else {
                    setInformation((prevData) => ({
                      ...prevData,
                      recipient_endpoint_type_id: 0,
                      endpoint_type_name:null
                    }));
                  }
                }}
                disableClearable
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="outlined"
                    // InputProps={{
                    //   ...params.InputProps,
                    //   endAdornment: (
                    //     <InputAdornment
                    //       position="end"
                    //       style={{ position: "absolute", right: 20 }}
                    //     >
                    //       <img
                    //         src="assets/Images/searchicon.svg"
                    //         alt="Search Icon"
                    //       />
                    //     </InputAdornment>
                    //   ),
                    // }}
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="recipient_endpoint_address">
              Endpoint Address<span style={{color:"red"}}>*</span>
            </InputLabel>
            <TextField
              id="recipient_endpoint_address"
              size="small"
              value={information.recipient_endpoint_address}
              onChange={handleChange}
              variant="outlined"
              fullWidth
            />
          </Grid>

          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <InputLabel htmlFor="recipient_endpoint_username">
              Endpoint UserName<span style={{color:"red"}}>*</span>
            </InputLabel>
            <TextField
              id="recipient_endpoint_username"
              size="small"
              value={information.recipient_endpoint_username}
              onChange={handleChange}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <InputLabel htmlFor="recipient_endpoint_password">
              Endpoint Password<span style={{color:"red"}}>*</span>
            </InputLabel>
            <TextField
              id="recipient_endpoint_password"
              size="small"
              value={information.recipient_endpoint_password}
              onChange={handleChange}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <InputLabel htmlFor="recipient_endpoint_folder">
              Endpoint Folder
            </InputLabel>
            <TextField
              id="recipient_endpoint_folder"
              size="small"
              value={information.recipient_endpoint_folder}
              onChange={handleChange}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <InputLabel htmlFor="recipient_endpoint_port">
              Endpoint Port
            </InputLabel>
            <TextField
              id="recipient_endpoint_port"
              size="small"
              value={information.recipient_endpoint_port}
              onChange={handleChange}
              variant="outlined"
              fullWidth
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            />
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "right" }}>
            <Button
              id="back-button"
              variant="contained"
              color="secondary"
              onClick={() =>handle_EditEntity(information,setInformation)}
            >
              Save Changes
            </Button>
          </Grid>
        </Grid>
      </div>
    </Drawer>
  );
};

export default Editmaintain;
